export default "__VITE_ASSET__fd0b6909__"